import { createContext } from 'react';

const FavoritesContext = createContext(void 0);

FavoritesContext.displayName = 'context(Favorites)';

export default FavoritesContext;